import React from "react";
import { RouteComponentProps } from "react-router";
import ViewVenue from "sweet-web/components/Venue/ViewVenue";

const Preview: React.FC<RouteComponentProps> = props => {
  return <ViewVenue preview={true} {...props} />;
};

export default Preview;
